import { Record } from 'immutable';

export const ForgotPassword = new Record({
    success: false,
    action: '',
    validation_code: '',
    message: null,
    code: null,
    isPending: false,
    type: null,
    data: null,
    reset: false,
    belong_to_any_account: false,
    error_description: null
});